import React from 'react';
import { Redirect } from 'react-router-dom';

import SigninTemplate from '../components/common/template/SigninTemplate';
import { useSignIn } from '../Hooks/useAuth';
import * as PATH from '../lib/routes/path';

const SigninPage = () => {
  const {
    state,
    inputRef,
    logged,
    isLoading,
    isValidateTrue,
    onChangeValue,
    onSignin,
  } = useSignIn();

  return logged ? (
    <>
      {sessionStorage.prevUrl === PATH.SIGNUP ? (
        <Redirect to={PATH.HOME} />
      ) : (
        <Redirect to={sessionStorage.prevUrl} />
      )}
    </>
  ) : (
    <SigninTemplate
      state={state}
      onChangeValue={onChangeValue}
      onSignin={onSignin}
      isValidateTrue={isValidateTrue}
      isLoading={isLoading}
      signInRef={inputRef}
    />
  );
};

export default SigninPage;
